export const QUERY_KEYS = {
  ACCESSORIES: 'accessories',
  PACKS: 'packs',
  SERVICE_PLAN: 'servicePlan',
  OPEN_CUSTOMISATION: 'customiseOpen',
};
